<template>
  <div>
    <canvas id="exportadoUsd" ref="exportadoUsd" width="400" height="400"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStyle } from "@coreui/coreui-pro/dist/js/coreui-utilities";

const CHART_COLORS = [
  getStyle("--primary"),
  getStyle("--secondary"),
  getStyle("--danger"),
  getStyle("--info"),
  getStyle("--warning"),
  getStyle("--success"),
  getStyle("--dark")
];

export default {
  name: "ExportadoUsd",
  props: {
    chartData: {
      type: Object,
      default: () => {}
    },
    dataReady: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chartSetup: {}
    };
  },
  methods: {
    prepareData() {
      const labels = this.chartData.labels;
      const dataset = this.chartData.dataset;
      const data = {
        type: "doughnut",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Pallets",
              data: dataset,
              backgroundColor: CHART_COLORS,
              borderWidth: 1,
              datalabels: {
                anchor: "center",
                align: "start",
                display: "auto",
                formatter: function (value, context) {
                  return new Intl.NumberFormat("es-CL").format(value) + " USD";
                }
              }
            }
          ]
        },
        plugins: [ChartDataLabels],
        options: {
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: "right"
            },
            datalabels: {
              color: "#043e73"
            },
            title: {
              display: false,
              align: "start",
              text: "Antiguedad de Stock"
            }
          }
        }
      };
      return data;
    },
    async buildChart() {
      console.log("building Chart...");
      let ctx = this.$refs.exportadoUsd.getContext("2d");
      const setup = await this.prepareData();
      let chartBuilded = false;
      const myChart = new Chart(ctx, setup);
    }
  },
  watch: {
    dataReady(newVal, oldVal) {
      console.log("dataReady", newVal);
      if (newVal) {
        setTimeout(() => {
          this.buildChart();
        }, 1000);
      }
    }
  },
  // mounted() {
  //   this.buildChart();
  // },
  beforeMount() {
    // this.prepareData();
  }
};
</script>

<style></style>
